import { render, staticRenderFns } from "./RincianMaterial.vue?vue&type=template&id=30dbc0bc&scoped=true"
import script from "./RincianMaterial.vue?vue&type=script&lang=js"
export * from "./RincianMaterial.vue?vue&type=script&lang=js"
import style0 from "./RincianMaterial.vue?vue&type=style&index=0&id=30dbc0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbc0bc",
  null
  
)

export default component.exports